import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=0355018d&scoped=true&"
import script from "./HeaderBar.vue?vue&type=script&lang=ts&"
export * from "./HeaderBar.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=0355018d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0355018d",
  null
  
)

export default component.exports